import { AuthProvider } from './global-provider';
import { XstateDevLogger } from './xstate/xstate-dev-logger';
import { RouterProvider } from './router';
import './app.scss';

function App({ sentryReady }: { sentryReady: Promise<void> }) {
  return (
    <XstateDevLogger>
      <AuthProvider>
        <RouterProvider sentryReady={sentryReady} />
      </AuthProvider>
    </XstateDevLogger>
  );
}

export default App;
